/**
 * @file
 * Tabs functionality.
 */

(($, { behaviors }) => {
  /**
   * Change tabs.
   *
   * @param {$targetedTab} $targetedTab
   *   The currently targeted tab element.
   */
  function changeTabs($targetedTab) {
    const parent = $targetedTab.parent();
    const grandGrandParent = parent.parent().parent();
    const currentPanel = $(`#${$targetedTab.attr("aria-controls")}`);

    // Remove all currently selected tabs.
    parent
      .find('[aria-selected="true"]')
      .attr("aria-selected", false)
      .removeClass("is-active");

    // Set the current target to selected.
    $targetedTab.attr("aria-selected", true).addClass("is-active");

    // Hide all tab panels.
    grandGrandParent
      .find('[role="tabpanel"]')
      .attr("hidden", true)
      .removeClass("is-expanded");

    // Show the selected panel.
    currentPanel.attr("hidden", false).addClass("is-expanded");
  }

  /**
   * Initiate tabs click functionality.
   */
  function initiateTabsClickFunctionality() {
    const $allTabs = $(".js-tabs__tab");

    $allTabs.on("click", (event) => {
      const $targetedTab = $(event.currentTarget);

      // Run change tabs function on tabs click.
      changeTabs($targetedTab);
    });
  }

  /**
   * Keyboard navigation functionality for a tablist element.
   */
  function initiateTablistKeyboardNavigation() {
    const $tabsList = $(".js-tabs__list");

    $tabsList.each((index, element) => {
      const $list = $(element);
      const $tab = $list.find(".js-tabs__tab");
      const arrowLeft = 37;
      const arrowRight = 39;

      // Enable arrow navigation between tabs in the tab list.
      let tabFocus = 0;

      $list.on("keydown", (event) => {
        if (event.keyCode === arrowLeft || event.keyCode === arrowRight) {
          $tab[tabFocus].setAttribute("tabindex", -1);
          // If user moves to the right.
          if (event.keyCode === arrowRight) {
            tabFocus += 1;
            // If we're at the end, go to the start.
            if (tabFocus >= $tab.length) {
              tabFocus = 0;
            }
            // If user moves to the left.
          } else if (event.keyCode === arrowLeft) {
            tabFocus -= 1;
            // If we're at the start, move to the end.
            if (tabFocus < 0) {
              tabFocus = $tab.length - 1;
            }
          }

          $tab[tabFocus].setAttribute("tabindex", 0);
          $tab[tabFocus].focus();
        }
      });
    });
  }

  /**
   * Attaches behaviors for tabs functionality.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *  Attaches tabs functionality.
   */
  behaviors.tabs = {
    attach() {
      // Initiate tabs click functionality on load.
      initiateTabsClickFunctionality();

      // Initiate tablist keyboard navigation functionality on load.
      initiateTablistKeyboardNavigation();
    }
  };
})(jQuery, Drupal);
